import dayjs from 'dayjs';
import * as yup from 'yup';

import { ERRORS_TEXTS } from '../../../../../const/validation';

export const schema = yup.object({
  name: yup.string().required(ERRORS_TEXTS.required),
  serviceType: yup.string().required(ERRORS_TEXTS.required),
  clientConditions: yup.string().required(ERRORS_TEXTS.required),
  clientConditionsDays: yup
    .number()
    .nullable()
    .transform((value, original) => (original === '' || original === null ? null : value))
    .min(0, ERRORS_TEXTS.positive),
  strategyIds: yup.array().of(yup.string()).min(1, ERRORS_TEXTS.minItems).required(ERRORS_TEXTS.required),
  tariffId: yup.string().required(ERRORS_TEXTS.required),
  tariffDisplayValue: yup.string().notRequired(),
  tariffDescription: yup.string().notRequired(),
  tariffInfo: yup.string().notRequired(),
  startDate: yup.string().nullable().required(ERRORS_TEXTS.required),
  endDate: yup
    .string()
    .nullable()
    .required(ERRORS_TEXTS.required)
    .test('endDate-after-startDate', 'Дата завершения не может быть раньше даты начала', function (value) {
      const { startDate } = this.parent;

      if (!value || !startDate) return true;

      return !dayjs(value).isBefore(dayjs(startDate), 'day');
    }),
  returnDate: yup
    .string()
    .nullable()
    .transform((value, original) => (original === '' ? null : value))
    .test('returnDate-after-endDate', 'Дата смены тарифа не может быть раньше даты завершения', function (value) {
      const { endDate } = this.parent;

      if (!value || !endDate) return true;

      return !dayjs(value).isBefore(dayjs(endDate), 'day');
    })
    .test(
      'returnDate-or-limitTime',
      'Может быть задано только одно из: дата смены тарифа или срок нахождения на акции',
      function (value) {
        const { limitTime } = this.parent;

        if (!value) return true;

        return limitTime === null || limitTime === undefined || limitTime === 0;
      },
    ),
  limitTime: yup
    .number()
    .nullable()
    .transform((value, original) => (original === '' || original === null ? null : value))
    .min(0, ERRORS_TEXTS.positive)
    .test(
      'limitTime-or-returnDate',
      'Может быть задано только одно из: дата смены тарифа или срок нахождения на акции',
      function (value) {
        const { returnDate } = this.parent;

        if (value === null || value === undefined || value === 0) return true;

        return !returnDate;
      },
    ),
});
